module.exports = __webpack_public_path__ + "static/favicon-d49b28463468d9503ea16bfb2dfc5409.png";